const hasClass = (el, className) => (
  el.classList ? el.classList.contains(className) : new RegExp(`\\b${className}\\b`).test(el.className)
);

const removeClass = (elem, className) => {
  if (hasClass(elem, className)) {
    const str = ` ${elem.className} `;
    elem.className = str.replace(` ${className} `, ' ').replace(/^\s+|\s+$/g, '');
  }
};

const addClass = (elem, className) => {
  if (!hasClass(elem, className)) {
    elem.className += (` ${className}`);
  }
};

export {
  addClass,
  removeClass,
  hasClass,
};


